import { render, staticRenderFns } from "./privacyPolicyMatrix.vue?vue&type=template&id=075479b2&scoped=true"
import script from "./privacyPolicyMatrix.vue?vue&type=script&lang=js"
export * from "./privacyPolicyMatrix.vue?vue&type=script&lang=js"
import style0 from "./privacyPolicyMatrix.vue?vue&type=style&index=0&id=075479b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075479b2",
  null
  
)

export default component.exports